import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: '#000', color: '#fff', paddingTop: 44, paddingBottom: 22, borderTop: '1px solid #111' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 24px' }}>
        <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '130px 1fr 1.15fr 1fr 0.9fr', gap: 28, paddingBottom: 28, borderBottom: '1px solid #222' }}>

          {/* Brand */}
          <div>
            <img src="/logo-footer.png" alt="DPOS" style={{ height: 38, display: 'block', marginBottom: 12 }} />
          </div>

          {/* Product & Services */}
          <div>
            <h3 style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#9ca3af', marginBottom: 10 }}>Product & Services</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {[
                { label: 'POS', to: '/pos' },
                { label: 'Integrations', to: '/integrations' },
                { label: 'Online Ordering', to: '/online-ordering' },
                { label: 'Inventory', to: '/material-management' },
              ].map(item => (
                <Link key={item.label} to={item.to} style={{ fontSize: 13, color: '#d1d5db' }}
                  onMouseEnter={e => e.target.style.color = '#CC0000'}
                  onMouseLeave={e => e.target.style.color = '#d1d5db'}>{item.label}</Link>
              ))}
              {[
                'AMC / Networking',
                'Solutions',
                'Web Development',
                'Web Hosting Solutions',
                'Servers',
                'Laptops',
                'Peripherals',
                'POS Hardware',
                'Printers',
              ].map(label => (
                <span key={label} style={{ fontSize: 13, color: '#d1d5db' }}>{label}</span>
              ))}
            </div>
          </div>

          {/* DPOS Overview — part 1 */}
          <div>
            <h3 style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#9ca3af', marginBottom: 10 }}>DPOS Overview</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {[
                'POS (DPOS – Dynamic Point of Sale)',
                'DPOS Captain App (For Order Punching)',
                'DPOS QR E-Menu',
                'DPOS Menu Management',
                'DPOS E-Bill (Bill On WhatsApp)',
                'Merchant App (For Sales Reports Viewing)',
                'Inventory (MMS – Material Management System)',
                'Recipe Management',
                'Tally Integration',
                'Debit POS (Club Management System)',
                'KDS – Kitchen Display System',
              ].map(label => (
                <span key={label} style={{ fontSize: 13, color: '#d1d5db', lineHeight: 1.45 }}>{label}</span>
              ))}
            </div>
          </div>

          {/* DPOS Overview — part 2 (was Company's column) */}
          <div>
            <h3 style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'transparent', marginBottom: 10 }}>&nbsp;</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {[
                'POS Integration Swiggy / Zomato',
                'CRM Manage Customers',
                'Bank Integration (Razorpay / Mosambee)',
                'DPOS – Payroll Attendance',
                'PMS – Property Management System',
              ].map(label => (
                <span key={label} style={{ fontSize: 13, color: '#d1d5db', lineHeight: 1.45 }}>{label}</span>
              ))}
            </div>
          </div>

          {/* Contact (with Company links stacked below) */}
          <div>
            <h3 style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#9ca3af', marginBottom: 10 }}>Contact</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              <a href="mailto:shabnamsayed228@gmail.com" style={{ fontSize: 13, color: '#d1d5db', display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 16 }}>✉</span> shabnamsayed228@gmail.com
              </a>
              <a href="tel:+919920593222" style={{ fontSize: 13, color: '#d1d5db', display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 16 }}>📞</span> +91 99205 93222
              </a>
              <div style={{ fontSize: 13, color: '#d1d5db', display: 'flex', alignItems: 'flex-start', gap: 8 }}>
                <span style={{ fontSize: 16, marginTop: 2 }}>📍</span>
                <span>208 B WING, GOLDEN SOIL CHSL, NEXT TO RAJ NAGAR OPP AYESHA TOWER JOGESHWARI WEST, MUMBAI, Mumbai Suburban, Maharashtra, 400102</span>
              </div>
              <a href="https://www.instagram.com/d_pos__/" target="_blank" rel="noopener noreferrer"
                style={{ fontSize: 13, color: '#d1d5db', display: 'flex', alignItems: 'center', gap: 8, textDecoration: 'none' }}
                onMouseEnter={e => { e.currentTarget.style.color = '#E1306C'; }}
                onMouseLeave={e => { e.currentTarget.style.color = '#d1d5db'; }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                @d_pos__
              </a>
              <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px solid #222' }}>
                <h3 style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#9ca3af', marginBottom: 6 }}>Company</h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <Link to="/contact" style={{ fontSize: 13, color: '#d1d5db' }}
                    onMouseEnter={e => e.target.style.color = '#CC0000'}
                    onMouseLeave={e => e.target.style.color = '#d1d5db'}>Contact</Link>
                  <Link to="/terms" style={{ fontSize: 13, color: '#d1d5db' }}
                    onMouseEnter={e => e.target.style.color = '#CC0000'}
                    onMouseLeave={e => e.target.style.color = '#d1d5db'}>Terms</Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{ paddingTop: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <p style={{ fontSize: 13, color: '#6b7280' }}>Copyright © 2026 DGPOS LLP. All rights reserved</p>
          <p style={{ fontSize: 13, color: '#6b7280' }}>
            Powered by <span style={{ color: '#CC0000', fontWeight: 600 }}>DPOS</span>
          </p>
          <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
            <Link to="/privacy" style={{ fontSize: 13, color: '#6b7280' }}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = '#6b7280'}>Privacy Policy</Link>
            <Link to="/terms" style={{ fontSize: 13, color: '#6b7280' }}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = '#6b7280'}>Terms</Link>
            <Link to="/cancellation-policy" style={{ fontSize: 13, color: '#6b7280' }}
              onMouseEnter={e => e.target.style.color = '#fff'}
              onMouseLeave={e => e.target.style.color = '#6b7280'}>Cancellation & Refund Policy</Link>
          </div>
        </div>
      </div>

      <style>{`@media(max-width:768px){.footer-grid{grid-template-columns:1fr !important;}}`}</style>
    </footer>
  );
}
